import { render, staticRenderFns } from "./ResourceIndex.vue?vue&type=template&id=abc10afc&scoped=true&"
import script from "./ResourceIndex.vue?vue&type=script&lang=js&"
export * from "./ResourceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc10afc",
  null
  
)

export default component.exports